import { motion } from "framer-motion";

/**
 * A single-line, slow editorial marquee. One repeating strip that
 * cycles endlessly. Fully decorative — set aria-hidden.
 */
export default function Marquee({ items, duration = 40, className = "" }) {
  const strip = [...items, ...items];
  return (
    <div className={`relative w-full overflow-hidden select-none ${className}`} aria-hidden>
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {strip.map((item, i) => (
          <span key={i} className="flex items-center gap-8 px-8">
            <span>{item}</span>
            <span className="text-brand-gold text-3xl leading-none">✦</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
